module.exports = __webpack_public_path__ + "static/media/galerija_2022_0014.a00eb8e0.jpg";